import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUtensils, FaFilm, FaMoon } from 'react-icons/fa';
import Footer from '../components/Footer';

const getNairobiHour = () => {
  const now = new Date();
  const nairobiTime = new Intl.DateTimeFormat('en-KE', {
    timeZone: 'Africa/Nairobi',
    hour: 'numeric',
    hour12: false,
  }).format(now);
  return parseInt(nairobiTime, 10);
};

const isOrderingClosed = () => {
  const hour = getNairobiHour();
  return hour >= 22 || hour < 9;
};

const HomePage = () => {
  const navigate = useNavigate();

  if (isOrderingClosed()) {
    return (
      <div className="home-page">
        <div className="home-header">
          <img src="/assets/images/logo.png" alt="Westgate" className="home-logo" />
          <h1>Concessions</h1>
        </div>
        <div className="closed-message">
          <div className="closed-icon">
            <FaMoon />
          </div>
          <h2>Good evening!</h2>
          <p>
            Unfortunately, we do not process orders past <strong>10:00 PM</strong> and before <strong>9:00 AM</strong>.
          </p>
          <p className="closed-hours">
            Orders are accepted between <strong>9:00 AM – 10:00 PM</strong>.
          </p>
          <p className="closed-subtext">Please try during operating hours. Thank you!</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="home-page">
      <div className="home-header">
        <img src="/assets/images/logo.png" alt="Westgate" className="home-logo" />
        <h1>Concessions</h1>
      </div>
      
      <div className="menu-selection">
        <div 
          className="menu-option kitchen-option"
          onClick={() => navigate('/kitchen')}
        >
          <div className="menu-icon">
            <FaUtensils />
          </div>
          <h2>Kitchen & Bar</h2>
          <p>Food, drinks, and beverages</p>
        </div>
        
        <div 
          className="menu-option kiosk-option"
          onClick={() => navigate('/snacks')}
        >
          <div className="menu-icon">
            <FaFilm />
          </div>
          <h2>Cinema Kiosk</h2>
          <p>Snacks and refreshments</p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default HomePage;
